import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-fondos',
  templateUrl: './fondos.component.html',
  styleUrls: ['./fondos.component.scss']
})
export class FondosComponent {
  constructor(private loginService: LoginService) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }

}
